module.exports = __webpack_public_path__ + "assets/img/car13.9e9743f7.jpg";